<template>
  <div>
    <div class="report">
        <page-title-secondary title="提交漏洞" />
        <div class="report__content">
          <div class="report__form">
            <xui-form ref="ruleForm" :model="ruleForm" :rules="rules">
               <div class="report__form-row--one"> 
                  <div class="xui-form-item__label is-required">漏洞名称</div>
                  <xui-form-item ref="ruleFormName" label="" prop="vulTitle">
                    <xui-input v-model.trim="ruleForm.vulTitle" placeholder="请输入漏洞名称，特殊字符除外"></xui-input>
                  </xui-form-item>
               </div>

                <div class="report__form-row--two">
                  <div class="xui-form-item__label is-required">漏洞类型</div>
                  <xui-form-item label="" prop="vulTypeId">
                    <xui-select v-model.trim="ruleForm.vulTypeId" placeholder="请选择漏洞类型" @change="changeVulType">
                      <xui-option v-for="item in vulTypeOption" :key="item.itemCode" class="item-dropdown" :label="item.itemName" :value="item.itemCode" />
                    </xui-select>
                  </xui-form-item>
                  <xui-form-item prop="vulSubtypeId" class="second-item">
                    <xui-select v-model.trim="ruleForm.vulSubtypeId" placeholder="请选择漏洞类型">
                      <xui-option v-for="item in vulSubTypeOption" :key="item.itemCode" class="item-dropdown" :label="item.itemName" :value="item.itemCode" />
                    </xui-select>
                  </xui-form-item>
                </div>
                 
                <div class="report__form-row--two">
                  <div class="xui-form-item__label is-required">所属业务</div>
                  <xui-form-item label="" prop="orgId">
                    <xui-select v-model.trim="ruleForm.orgId" placeholder="请选择所属业务" @change="changeOrgId">
                      <xui-option v-for="item in orgIdOption" :key="item.itemCode" class="item-dropdown" :label="item.itemName" :value="item.itemCode" />
                    </xui-select>
                  </xui-form-item>
                  <xui-form-item prop="productId" class="second-item">
                    <xui-select v-model.trim="ruleForm.productId" placeholder="请选择所属业务">
                      <xui-option v-for="item in productIdOption" :key="item.itemCode" class="item-dropdown" :label="item.itemName" :value="item.itemCode" />
                    </xui-select>
                  </xui-form-item>
                </div>

                <div class="report__form-row--one"> 
                  <div class="xui-form-item__label is-required">漏洞等级</div>
                   <xui-form-item label="" prop="vulLevel">
                  <xui-select v-model.trim="ruleForm.vulLevel" placeholder="请选择漏洞等级">
                    <xui-option v-for="item in levelOption" :key="item.key" class="item-dropdown" :label="item.label" :value="item.key" />
                  </xui-select>
                </xui-form-item>
               </div>

                <div class="report__form-row--one"> 
                  <div class="xui-form-item__label">漏洞URL</div>
                  <xui-form-item label="" prop="vulUrl" class="item-url">
                    <xui-input v-model.trim="ruleForm.vulUrl" placeholder="请输入漏洞URL"></xui-input>
                  </xui-form-item>
               </div>

               

              <div class="report__form-row--one"> 
                  <div class="xui-form-item__label is-required">漏洞详情</div>
                   <xui-form-item label="" prop="content">
                  <quill-editor id="quill_editor" ref="QuillEditor" v-model="ruleForm.content" class="report__quill-editor" :options="editorOption5" @change="changeEditor"></quill-editor>
                </xui-form-item>
                <xui-upload
                  class="report__form-upload"
                  :action="actionImg"
                  :before-upload="beforUploadPic"
                  :headers="xCsrfToken"
                  :on-error="reportError"
                  show-overflow-tooltip
                  :on-success="handlePreview"
                  multiple
                  style="display: none;"
                  :with-credentials="true"
                >
                  <xui-button id="upload" size="medium" style="display:none;" icon="fa fa-upload">上传</xui-button>
                </xui-upload>
               </div>

              <div class="report__form-row--one"> 
                  <div class="xui-form-item__label">上传附件</div>
                  <xui-form-item label="" prop="attachmentList" class="is-overflow-hidden">
                    <xui-upload
                      class="report__form-upload"
                      :action="actionZip"
                      :headers="xCsrfToken"
                      :limit="1"
                      :on-error="reportError"
                      show-overflow-tooltip
                      accept=".zip,.7z,.rar"
                      :on-remove="resetFile"
                      :before-upload="beforUploadZip"
                      :on-exceed="handleExceed"
                      :file-list="ruleForm.fileList"
                      :on-success="handlePreviewZip"
                      :with-credentials="true"
                    >
                      <a id="uploadZip" class="report__form-button--upload" href="javascript:void(0);">选择文件</a>
                      <div slot="tip" class="report__form-tip--upload">
                        格式限制:7z,rar,zip格式,不超过200M。 <span v-if="uploadMsg" class="upload_msg-scan"> {{ uploadMsg }} </span>
                      </div>
                    </xui-upload>
                  </xui-form-item>
               </div>

                  <div class="report__form-row--one"> 
                  <div class="xui-form-item__label is-required">完成验证</div>
                  <xui-form-item label="" class="is-required">
                    <div id="captcha" ref="captcha"></div>
                  </xui-form-item>
               </div>

                <xui-form-item>
                  <div class="report__form-button--summary">在漏洞未修复之前，请不要向外界传播</div>
                </xui-form-item>

                <div class="report__form-row--submit">
                  <xui-button :disabled="submitDisabled" class="report__form-button--submit" @click="submitForm('ruleForm')">提交漏洞</xui-button>
                </div>
            </xui-form>
          </div>

          <div class="report__program">
            <div class="report__program-title">各奖励计划漏洞评分规则：</div>
            <div class="program-valid-list">
              <ul>
                <li v-for="it in rewardData" :key="it.title" class="program-valid-item">
                  <router-link class="report__program-link" :to="{ path: '/program/detail', query: { code: it.announcementId } }">
                    {{ it.title }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
    </div>
    <!-- 荣耀安全应急响应中心服务条款弹框 -->
    <xui-dialog title="" class="warnning-wrap" :close-on-click-modal="false" showcenter :visible.sync="dialogVisible" :width="$store.state.isMobile ? '80%': '30%'" :before-close="handleClose">
      <h3 :style="{'font-size': $store.state.isMobile ? '24px': '16.5px'}">荣耀安全应急响应中心服务条款</h3>
      <div class="content-wrap" :style="{'font-size': $store.state.isMobile ? '22px': '14px'}">
        <p>欢迎您使用荣耀安全应急响应中心（Honor Security Response Center）服务，本平台在特定场景下需收集您的如下信息:</p>
        <ul>
          <li>真实姓名，身份证正反面照片及身份证号；</li>
          <li>银行卡号，开户行信息，银行名称；</li>
          <li>手机号码，邮寄地址；</li>
          <li>昵称，头像，邮箱，主页；</li>
          <li>QQ，微信，签名，团队；</li>
          <li>IP地址；</li>
          <li>为防止欺骗行为，荣耀需采集浏览器信息（类型、时区、插件、语言、字体、canvas图片渲染哈希值、webgl图片渲染哈希值）；</li>
        </ul>
        <p>上述数据将会传输并保存至位于中华人民共和国境内的服务器。</p>
        <span
          >点击“同意”，即表示您同意
          <a :href="safetyURL" target="_blank" class="honor-security-user-protocol">荣耀安全应急响应中心用户协议</a>
          ，并知悉
          <a :href="privacyURL" target="_blank" class="honor-security-secret-statement">关于安全应急响应中心与隐私的声明</a>。</span
        >
      </div>
      <span slot="footer" center>
        <xui-button size="bigger" @click="handleClose">取消</xui-button>
        <xui-button type="primary" size="bigger" @click="confirm">同意</xui-button>
      </span>
    </xui-dialog>

    <!-- 漏洞提交成功弹框 -->
    <xui-dialog title="" class="submit-wrap" :close-on-click-modal="false" showcenter :visible.sync="submitSuccess" width="30%" @close="resetThePage">
      <div class="dia-body">
        <div class="img-and-title">
          <template v-if="success">
            <img class="img-success" src="../../images/settingSuccess.jpg" />
          </template>
          <template v-else>
            <img class="img-success" src="../../images/settingError.png" />
          </template>
          <span class="report-tip-title">漏洞提交成功</span>
        </div>
        <div v-show="complete" class="dialog__body">
          <div class="report-tip"><i class="fa fa-engine-warning"></i> <span>您还未完善您的个人信息</span></div>
          <p>建议您在收到漏洞奖金支付消息通知时，及时完善您的身份认证资料，便于及时支付漏洞奖金。</p>
        </div>
      </div>
      <span v-show="complete" slot="footer" class="dialog-footer" center>
        <xui-button class="left" type="primary" size="bigger" @click="toIdInfo">完善个人信息</xui-button>
        <xui-button class="right" size="bigger" @click="resetThePage">以后再说</xui-button>
      </span>
    </xui-dialog>

    <!-- 登录提示弹框 -->
    <xui-dialog v-if="isNotLogin && isEffect" title="失效提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" width="30%" @close="handleClose">
      <span>您的账号已经失效，请联系管理员</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="handleClose">返回首页</xui-button>
      </span>
    </xui-dialog>
    <xui-dialog v-else title="登录提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" width="30%" @close="handleClose">
      <span>系统检测到您未登录或登录失效，请先登录</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="login">荣耀账号登录</xui-button>
      </span>
    </xui-dialog>
  </div>
</template>

<script>
import HomeHeader from '../../components/Header.vue';
import { quillEditor } from 'vue-quill-editor';
import PageTitleSecondary from '../../components/pages/PageTitleSecondary'
// 导入富文本编辑器样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill';
import { v4 } from 'uuid';
// import '../../statics/global/gt.js'
import store from '../../store/index'

let checkAgePromise = null
export default {
  name: 'report',
  components: { HomeHeader, quillEditor, PageTitleSecondary },
  data() {
    const _this = this
    return {
      safetyURL: '',
      privacyURL: '',
      isEffect: false,
      xCsrfToken: null,
      geetestObj: {},
      waitShow: true,
      textShow: true,
      geetest_challenge: null,
      geetest_validate: null,
      geetest_seccode: null,
      rewardData: [],
      logoUrl: '',
      complete: false,
      completeFlag: false,
      underage:false,
      isNotLogin: false,
      success: true,
      submitSuccess: false,
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      submitDisabled: false,
      actionImg: this.$baseURL + 'vul/hsrc/vul/report/servlet/uploadFile?ulType=VulUploadImg&dir=HtmlAreaImage', // 富文本编辑器上传图片
      actionZip: this.$baseURL + 'vul/hsrc/vul/report/servlet/uploadFile?ulType=VulUploadAttach&dir=VulAttach&businessType=VUL_SUBMIT_PHASE', // 上传附件，压缩包
      ruleForm: {
        vulTitle: '',
        vulTypeId: '',
        vulSubtypeId: '',
        orgId: '',
        productId: '',
        vulLevel: '',
        fileList: [],
        vulUrl: '',
        content: '',
        attachmentList: [{ attachmentId: null }],
        check: true
      },
      orgIdOption: [],
      productIdOption: [],
      productId1Option: [
        {
          key: 11,
          label: '荣耀官网',
          value: 11
        },
        {
          key: 12,
          label: '荣耀商城',
          value: 12
        },
        {
          key: 13,
          label: '荣耀账号',
          value: 13
        }
      ],
      productId2Option: [
        {
          key: 21,
          label: '荣耀50',
          value: 21
        },
        {
          key: 22,
          label: '荣耀magic3',
          value: 22
        }
      ],
      levelOption: [
        {
          key: 4,
          label: '低危',
          value: 4
        },
        {
          key: 3,
          label: '中危',
          value: 3
        },
        {
          key: 2,
          label: '高危',
          value: 2
        },
        {
          key: 1,
          label: '严重',
          value: 1
        }
      ],
      vulTypeOption: [],
      attachmentIdList: [],
      vulSubTypeOption: [],
      rules: {
        vulTitle: [
          { required: true, message: '请输入漏洞名称', trigger: 'blur' },
          {
            validator: function(rule, value, callback) {
              if (/[<>&\\"']/g.test(value) == true) {
                callback(new Error('请不要输入特殊字符'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          },
          { min: 0, max: 50, message: '最大输入长度50', trigger: 'change' }
        ],
        vulTypeId: [{ required: true, message: '请选择漏洞类型', trigger: 'change' }],
        vulSubtypeId: [{ required: true, message: '请选择漏洞类型', trigger: 'change' }],
        orgId: [{ required: true, message: '请选择所属业务', trigger: 'change' }],
        productId: [{ required: true, message: '请选择所属业务', trigger: 'change' }],
        vulLevel: [{ required: true, message: '请选择漏洞等级', trigger: 'change' }],
        vulUrl: [
          { min: 0, max: 330, message: '最大输入长度330', trigger: 'change' },
          {
            validator: function(rule, value, callback) {
              if (value) {
                const reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/;
                if (!reg.test(value)) {
                  callback(new Error('URL格式错误'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        content: [
          { 
            required: true,   
            validator: function(rule, value, callback) {
              if (!_this.getRealVal(value)) {
                callback(new Error('请输入漏洞详情'));
              } else {
                callback();
              }
            }, 
            trigger: 'change' 
          },
          { min: 0, max: 6000,message: '最大输入长度6000', trigger: 'change' }
        ]
      },
      arrMsg: [
        '您上传的文件无病毒',
        '检测到上传的附件存在病毒',
        '您上传的文件文件加密',
        '',
        '当前杀毒云系统扫描存在异常，可能原因为压缩包存在密码，建议下载文件后进行手工查杀'
      ],
      uploadMsg: '',
      pollingDataInterval: null,
      editorOption5: {
        theme: 'snow',
        placeholder: `一、受影响的Honor相关业务产品或组件：

请提供具体受影响Honor产品或组件名称，如手机详细版本号（可通过“设置->关于手机->版本号”来查看），应用APP名称及相应版本号（如：Honor浏览器中，通过”设置->关于”来查看）  


二、漏洞技术细节：

请提供该漏洞的技术细节，包括以下内容：1.详细描述漏洞技术细节；2.漏洞复现详细步骤；3. POC及漏洞证明。 


三、修复及缓解措施建议：`,
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // toggled buttons
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }], // custom button values
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }], // superscript/subscrip
              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ font: [] }],
              [{ align: [] }],
              ['clean'],
              ['link', 'image']
            ],
            handlers: {
              // handlers object will be merged with default handlers object
              shadeBox: null,
              image: function(value) {
                if (value) {
                  document.querySelector('#upload').click();
                  // this.quill.format('image', href);
                } else {
                  this.quill.format('image', false);
                }
              }
            }
          }
        }
      }
    };
  },
  mounted() {
    this.safetyURL = window.sessionStorage.getItem('safetyURL');
    this.privacyURL = window.sessionStorage.getItem('privacyURL');
    document.getElementsByClassName('xui-scrollbar__wrap')[0].scrollTo(0, 0);
    document.addEventListener('paste', this.pasteEvent, true);
    setTimeout(() => {
      this.getCSRF().then(res => {
        if (res) {
          this.getUserInfo();
        }
      });
      // 确认是否登录
    }, 100);
  },
  beforeDestroy() {
    if (this.pollingDataInterval) {
      clearInterval(this.pollingDataInterval);
    }
    document.removeEventListener('paste', this.pasteEvent, true);
  },
  created() {},
  methods: {
    pasteEvent(event,val) {
      console.log(event,'event11')
      if (
        (event.currentTarget.activeElement &&
        event.currentTarget.activeElement.offsetParent &&
        event.currentTarget.activeElement.offsetParent.className.includes('ql-container') &&
        event.clipboardData.files &&
        event.clipboardData.files.length &&
        event.clipboardData.types.length === 1 &&
        event.clipboardData.files[0].name === 'image.png')||(val&&val=="past")
      ) {
        let uploadFile
        if(val&&val=="past"){
          uploadFile=event;
        }else{
          uploadFile=event.clipboardData.files[0];
        }
        console.log(uploadFile,'uploadFile')
        // this.beforUploadPic(uploadFile).then(res => {
          if (this.beforUploadPic(uploadFile)) {
            const Token = window.sessionStorage.getItem('x-csrf-token');
            // const clipText = event.clipboardData.files[0];
            const clipText = uploadFile;
            const formData = new FormData();
            formData.append('file', clipText);
            this.$http
              .post('vul/hsrc/vul/report/servlet/uploadFile?ulType=VulUploadImg&dir=HtmlAreaImage', formData, { headers: { 'x-csrf-token': Token } })
              .then(res => {
                if (res.data && res.status === 200) {
                  this.logoUrl = `https://${this.$baseU}.honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/res/image?attachmentId=${res.data[0]}`;
                  this.attachmentIdList.push(res.data[0]);
                  const content = this.ruleForm.content;
                  const imgReg = /<img.*?(?:>|\/>)/gi; // 匹配图片中的img标签
                  const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
                  const arr = content.match(imgReg); // 筛选出所有的img
                  const srcArr = [];
                  if (arr != null) {
                    for (let i = 0; i < arr.length; i++) {
                      const src = arr[i].match(srcReg);
                      // 获取图片地址判断是否是base64格式
                      if (src[1].indexOf('base64') !== -1) {
                        srcArr.push(src[1]);
                      }
                    }
                  }
                  srcArr.forEach(item => {
                    this.ruleForm.content = content.replace(item, this.logoUrl);
                  });
                }
              })
              .catch(error => {
                const content = this.ruleForm.content;
                const imgReg = /<img.*?(?:>|\/>)/gi; // 匹配图片中的img标签
                const arr = content.match(imgReg);
                const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
                const base64Image = [];
                if (arr != null) {
                  for (let i = 0; i < arr.length; i++) {
                    const src = arr[i].match(srcReg);
                    // 获取图片地址判断是否是base64格式
                    if (src[1].indexOf('base64') > -1) {
                      base64Image.push(arr[i]);
                    }
                  }
                }
                base64Image.forEach(async item => {
                  this.ruleForm.content = await content.replace(item, '');
                });
              });
          }
        // });
      }
    },
    resetFile() {
      if (this.pollingDataInterval) {
        clearInterval(this.pollingDataInterval);
      }
      this.ruleForm.attachmentList = [{ attachmentId: null }];
      this.uploadMsg = '';
      this.submitDisabled = false;
    },
    validDataUrl(s) {
        const validDataUrl = /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*?)\s*$/i;
        return validDataUrl.test(s);
    },
    getRealVal(str){
      let content=str;

      // content = content.replace(/<\/p>/g, '');
      // content = content.replace(/<strong>/g, '');
      // content = content.replace(/<\/strong>/g, '');
      // content = content.replace(/<em>/g, '');
      // content = content.replace(/<\/em>/g, '');
      // content = content.replace(/<h1>/g, '');
      // content = content.replace(/<\/h1>/g, '');
      // content = content.replace(/<h2>/g, '');
      // content = content.replace(/<\/h2>/g, '');
      // content = content.replace(/<blockquote>/g, '');
      // content = content.replace(/<\/blockquote>/g, '');
      // content = content.replace(/<u>/g, '');
      // content = content.replace(/<\/u>/g, '');
      // content = content.replace(/<span class="ql-cursor">/g, '');
      // content = content.replace(/<\/span>/g, '');
      // content = content.replace(/<pre class="ql-syntax" spellcheck="false">/g, '');
      // content = content.replace(/<\/pre>/g, '');
      // content = content.replace(/&nbsp;/g, '');
      // content = content.replace(/<br>/g, '');
      // content = content.replace(/<p>/g, '');
      // content = content.replace(/<p(.)+>/g, '');


      content = content.replace(/(\n)/g, "");
      content = content.replace(/(\t)/g, "");
      content = content.replace(/(\r)/g, "");
      // content = content.replace(/<\/?[^>]*>/g, "");
      content = content.replace(/<(?!\/?img)[^<>]*>/ig,'')//只保留img标签
      content = content.replace(/\s*/g, "");

      return content
    },
    dataURLtoFile(dataurl, filename) {//将base64转换为⽂件
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    },
    changeEditor() {
      const content = this.getRealVal(this.ruleForm.content);
      console.log('content：' + content)
      if(content.includes('<img')&&content.includes('src=')&&content.includes('data:image')&&content.includes('base64')){
        const str=content.substring(content.indexOf('src="')+5,content.length-2)
        const fileImg=this.dataURLtoFile(str,"123.png")
        this.pasteEvent(fileImg,'past')
      }
      const imgReg = /<img.*?(?:>|\/>)/gi; // 匹配图片中的img标签
      const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
      const arr = content.match(imgReg);
      // console.log(arr,'arr')
      const srcImageArr = [];
      if (arr != null) {
        for (let i = 0; i < arr.length; i++) {
          const src = arr[i].match(srcReg);
          // 获取图片地址判断是否是base64格式
          if (src[1] === '//:0') {
            srcImageArr.push(arr[i]);
          }
        }
      }
      if (srcImageArr.length) {
        srcImageArr.forEach(item => {
          this.$nextTick(() => {
            this.ruleForm.content = content.replace(item, '');
          });
        });
      }
      this.$refs.ruleForm.validateField('content');
    },
    reportError(err) {
      const callError = JSON.parse(err.message);
      this.$message.error(callError.message||'上传失败，请稍后再试！');
    },
    xssDefend(str) {
      if (typeof str !== 'string') {
        return '';
      }
      const html = window.filterXSS(str, {
        whiteList: {
          table: ['width', 'border', 'align', 'valign'],
          tbody: ['align', 'valign', 'text-align'],
          td: ['width', 'rowspan', 'colspan', 'align', 'valign'],
          tfoot: ['align', 'valign'],
          th: ['width', 'rowspan', 'colspan', 'align', 'valign'],
          thead: ['align', 'valign', 'text-align'],
          tr: ['rowspan', 'align', 'valign', 'text-align'],
          tt: [],
          a: ['target', 'href', 'title'],
          abbr: ['title'],
          address: [],
          area: ['shape', 'coords', 'href', 'alt'],
          article: [],
          aside: [],
          b: [],
          bdi: ['dir'],
          bdo: ['dir'],
          big: [],
          blockquote: ['cite'],
          br: [],
          caption: [],
          center: [],
          cite: [],
          code: [],
          col: ['align', 'valign', 'span', 'width'],
          colgroup: ['align', 'valign', 'span', 'width'],
          dd: [],
          del: ['datetime'],
          details: ['open'],
          div: [],
          dl: [],
          dt: [],
          em: [],
          font: ['color', 'size', 'face'],
          footer: [],
          h1: [],
          h2: [],
          h3: [],
          h4: [],
          h5: [],
          h6: [],
          header: [],
          hr: [],
          i: [],
          img: ['src', 'alt', 'title', 'width', 'height'],
          ins: ['datetime'],
          li: [],
          mark: [],
          nav: [],
          ol: [],
          p: [],
          pre: [],
          s: [],
          section: [],
          small: [],
          span: [],
          sub: [],
          sup: [],
          strong: [],
          u: [],
          ul: [],
          p: ['style'],
          strong: ['style'],
          span: ['style'],
          br: [],
          img: ['style', 'src', 'border', 'width', 'height']
        },
        stripIgnoreTag: true, // 过滤所有非白名单标签的HTML
        stripIgnoreTagBody: ['script', 'iframe'] // script标签较特殊，需要过滤标签中间的内容
      });
      return html;
    },
    resetThePage: () => {
      location.reload();
    },
    // 获取漏洞类型
    getVulnStatus: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get(this.$baseURL + 'common/hsrc/vul/common/services/jalor/lookup/itemquery/list/findItemListByZhOrEn/VUL_TYPE/zh_CN', {
            headers: {
              'x-multi-consumer-appid': 'hsrc_vul-x-service-multi',
              appid: this.$appId,
              'x-celon-admin': true,
              'x-sub-app-id': 'hsrc_vul',
              'x-csrf-token': window.sessionStorage.getItem('x-csrf-token')
            }
          })
          .then(res => {
            if (res.data && res.status === 200) {
              this.vulTypeOption = res.data;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    // 获取漏洞子类型
    getVulnSubStatus: function(v) {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get(this.$baseURL + 'common/hsrc/vul/common/services/jalor/lookup/itemquery/list/VUL_SUB_TYPE/' + v + '/zh_CN', {
            headers: {
              'x-multi-consumer-appid': 'hsrc_vul-x-service-multi',
              appid: this.$appId,
              'x-celon-admin': true,
              'x-sub-app-id': 'hsrc_vul',
              'x-csrf-token': window.sessionStorage.getItem('x-csrf-token')
            }
          })
          .then(res => {
            if (res.data && res.status === 200) {
              this.vulSubTypeOption = res.data;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    // 获取漏洞所属业务
    getVulnBIZ: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get(this.$baseURL + 'common/hsrc/vul/common/services/jalor/lookup/itemquery/list/findItemListByZhOrEn/BIZ_TYPE/zh_CN', {
            headers: {
              'x-multi-consumer-appid': 'hsrc_vul-x-service-multi',
              appid: this.$appId,
              'x-celon-admin': true,
              'x-sub-app-id': 'hsrc_vul',
              'x-csrf-token': window.sessionStorage.getItem('x-csrf-token')
            }
          })
          .then(res => {
            if (res.data && res.status === 200) {
              this.orgIdOption = res.data;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    // 获取漏洞所属产品
    getVulnPRO: function(v) {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get(this.$baseURL + 'common/hsrc/vul/common/services/jalor/lookup/itemquery/list/PRODUCT_TYPE/' + v + '/zh_CN', {
            headers: {
              'x-multi-consumer-appid': 'hsrc_vul-x-service-multi',
              appid: this.$appId,
              'x-celon-admin': true,
              'x-sub-app-id': 'hsrc_vul',
              'x-csrf-token': window.sessionStorage.getItem('x-csrf-token')
            }
          })
          .then(res => {
            if (res.data && res.status === 200) {
              this.productIdOption = res.data;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    // 获取奖励计划
    getAnnouncementList: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .post('vul/hsrc/vul/report/services/announcement/list', { category: 3, stickyOrder: -1, status: 1 })
          .then(res => {
            if (res.data && res.status === 200) {
              this.rewardData = res.data.data;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    // 初始化验证码
    getGeetest: function() {
      const that = this;
      const s = new Promise((resolve, reject) => {
        this.$http
          .post(`vul/hsrc/vul/report/services/geetest/firstValidate`)
          .then(res => {
            //请检测data的数据结构， 保证data.gt, data.challenge, data.success有值
            if (res.data && res.data.status && res.data.status === 200) {
              const dataNew = res.data.data;
              this.textShow = false;
              this.waitShow = true;
              initGeetest(
                {
                  // 以下配置参数来自服务端 SDK,四个必填
                  gt: dataNew.gt, // 字符串	验证 id，极验后台申请得到
                  challenge: dataNew.challenge, // 字符串	验证流水号，服务端 SDK 向极验服务器申请得到
                  offline: dataNew.success === 1 ? false : true, // success为1表示服务器返回正常，offline为false [目前未走redis，所以暂定1为true]；
                  new_captcha: dataNew.newCaptcha, // 布尔	宕机情况下使用，表示验证是 3.0 还是 2.0，3.0 的 sdk 该字段为 true

                  product: 'float', // 产品形式，包括：float，popup
                  width: '300px'
                  // https: true,
                  // api_server: 'apiv6.geetest.com',
                },
                function(captchaObj) {
                  // 这里可以调用验证实例 captchaObj 的实例方法
                  captchaObj.appendTo('#captcha'); //将验证按钮插入到宿主页面中captchaBox元素内
                  captchaObj
                    .onReady(function() {
                      this.waitShow = false;
                    })
                    .onSuccess(function() {
                      const result = captchaObj.getValidate();
                      that.geetestObj = result;
                      that.ruleForm.geetestChallenge = result.geetest_challenge;
                      that.ruleForm.geetestValidate = result.geetest_validate;
                      that.ruleForm.geetestSeccode = result.geetest_seccode;
                      setTimeout(() => {
                        document.getElementsByClassName('geetest_success_logo')[0].style.display = 'none';
                      });
                    })
                    .onError(function(error) {
                      console.log(error);
                    });
                }
              );
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    // 确认个人签名
    confirm: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/autograph/save', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            // 保存成功后，放开修改
            if (res.status === 200) {
              this.dialogVisible = false;
              this.getAnnouncementList();
              this.getGeetest();
              this.getVulnStatus();
              this.getVulnBIZ();
            } else {
              this.dialogVisible = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    toIdInfo: function() {
      this.$router.push({ path: '/usercenter/idinfo' });
    },
    // 关闭登录弹框
    handleClose: function() {
      this.$router.push({ path: '/' });
    },
    login: function() {
      this.loginHandle();
    },
    // 点击登录
    loginHandle: function() {
      let client_id = '',
        login_channel = '',
        req_client_type = '',
        redirect_uri = '',
        scope = '';
      for (let metas = document.getElementsByTagName('meta'), i = 0; i < metas.length; ++i) {
        switch (metas[i].name) {
          case 'client_id':
            client_id = metas[i].content;
            break;
          case 'login_channel':
            login_channel = metas[i].content;
            break;
          case 'req_client_type':
            req_client_type = metas[i].content;
            break;
          case 'redirect_uri':
            redirect_uri = metas[i].content;
            break;
          case 'scope':
            scope = metas[i].content;
            break;
          default:
            break;
        }
      }
      const stautusData = v4();
      const authURL = window.location.host === 'security.honor.com' ? 'https://hnoauth-login-drcn.cloud.honor.com/oauth2/v3/authorize?' : 'https://hnoauth-login-test-drcn.cloud.honor.com/oauth2/v3/authorize?';
      const redirectUrl =
        authURL +
        'response_type=code&access_type=offline&state=' +
        stautusData +
        '&client_id=' +
        client_id +
        '&login_channel=' +
        login_channel +
        '&req_client_type=' +
        req_client_type +
        '&redirect_uri=' +
        redirect_uri +
        '&scope=' +
        scope;

      window.location.href = redirectUrl;
    },
    //检查年龄
    checkAge:function() {
      checkAgePromise = new Promise((resolve, reject) => {
        this.$http.get('vul/hsrc/vul/report/services/user/checkIdCardInfo', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
        .then(res => {
          if (res.data && res.data.status === 200 && res.data.data === 0){
            this.underage = true;
          }else if(res.data && res.data.status === 200 && res.data.data === 1){
            this.underage = false;
            this.$message.warning('您尚未填写身份证信息或填写无效，请先填写身份证信息')
          }else if(res.data && res.data.status === 200 && res.data.data === 2){
            this.underage = false;
            this.$message.warning('您尚未满18周岁，不允许提交漏洞，详情请联系白帽子管理员')
          }
          resolve(res.data.data);
        }) 
        .catch(error => {
          const errorCode = error;
          console.log(errorCode);
        });    
      })
      return checkAgePromise
    },
    // 确实是否登录
    getUserInfo: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/user/getUserInfo')
          .then(res => {
            if (res.data && res.data.status === 200) {
              // 如果是登录状态，就验证是否签名
              // this.query();
              this.getGeetest();
              this.getAnnouncementList();
              this.getVulnStatus();
              this.getVulnBIZ();
              // this.$bus.$emit('send', res.data.data.unReadSiteMsgCount);
              store.commit('setUnReadBbsCount', res.data.data.unReadBbsCount)
              store.commit('setUnReadMsgListCount', res.data.data.unReadMsgListCount)
              store.commit('setUnReadSiteMsgCount', res.data.data.unReadSiteMsgCount)
              // 确认是否完善个人信息
              if (res.data.data && res.data.data.bankCard && res.data.data.idCard) {
                this.completeFlag = true;
              } else {
                this.completeFlag = false;
              }
            } else {
              this.isNotLogin = true;
            }
          })
          .catch(error => {
            const errorCode = error;
            console.log(errorCode);
            if (error.response && error.response.data && error.response.data.code === 'hihonor.account.00010010') {
              this.isEffect = true;
              this.isNotLogin = true;
            }
          });
      });
    },
    getCSRF: function() {
      const that = this;
      const options = {
        withCredentials: true,
        headers: {
          'x-csrf-token': null
        }
      };

      return new Promise((resolve, reject) => {
        this.$http
          .get('common/hsrc/vul/common/services/jalor/web/support/workspace/current', {
            headers: {
              'x-multi-consumer-appid': 'hsrc_vul-x-service-multi',
              appid: this.$appId,
              'x-celon-admin': true,
              'x-sub-app-id': 'hsrc_vul',
              'x-csrf-token': window.sessionStorage.getItem('x-csrf-token')
            }
          })
          .then(res => {
            that.xCsrfToken = { 'x-csrf-token': res['headers']['x-csrf-token'] };
            window.sessionStorage.setItem('x-csrf-token', res['headers']['x-csrf-token']);
            resolve(true);
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制上传 1 个文件，如果需要重新上传，请先删除原先文件`);
    },
    // 查询签名
    query: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/autograph/query', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            // 接口直接返回布尔值，false时为未签名，弹出签名窗
            if (!res.data) {
              this.dialogVisible = true;
            } else {
              // 为true时，为签名验证已过，不需要签名
              // 已签名状态，就初始化验证码和奖励计划
              this.getGeetest();
              this.getAnnouncementList();
              this.getVulnStatus();
              this.getVulnBIZ();
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    changeVulType: function(v) {
      this.ruleForm.vulSubtypeId = '';
      this.getVulnSubStatus(v);
    },
    changeOrgId: function(v) {
      this.ruleForm.productId = '';
      this.getVulnPRO(v);
    },
    submitForm(form) {
      // let content = this.getRealVal(this.ruleForm.content);
      // console.log(content,'submitForm')
      // if(content!=''&&content.trim()!=''){
      //   if(content.length>6000){
      //     this.$message({
      //       message: '漏洞详情字段长度不得多于6000字符，请给与更正',
      //       type: 'warning'
      //     });
      //     return
      //   }
      // }
      // console.log(content,'content')
      this.$refs[form].validate(valid => {
        if (valid) {
          // 内容校验通过后，再次校验登录状态
          const s = new Promise((resolve, reject) => {
            this.$http
              .get('vul/hsrc/vul/report/services/user/getUserInfo')
              .then(res => {
                if (res.data && res.data.status === 200) {
                  // this.$bus.$emit('send', res.data.data.unReadSiteMsgCount);
                  store.commit('setUnReadBbsCount', res.data.data.unReadBbsCount)
                  store.commit('setUnReadMsgListCount', res.data.data.unReadMsgListCount)
                  store.commit('setUnReadSiteMsgCount', res.data.data.unReadSiteMsgCount)
                  // 登陆状态校验通过后，校验验证码状态
                  if (!this.geetestObj) {
                    return this.$message.warning('请完成验证');
                  }
                  this.add(this.ruleForm);
                } else {
                  this.isNotLogin = true;
                  return false;
                }
              })
              .catch(error => {
                console.log(error);
              });
          });
        } else {
          return false;
        }
      });
    },
    // 提交漏洞接口
    add: function(form) {
      const t = new Promise((resolve, reject) => {
        resolve(this.checkAge());
      })
      t.then(res => {
        if('0' !== res + ''){
          return;
        }
      });
      const that = this;
      const params = {
        vulTitle: form.vulTitle,
        orgId: form.orgId,
        productId: form.productId,
        vulTypeId: Number(form.vulTypeId),
        vulSubtypeId: Number(form.vulSubtypeId),
        vulUrl: form.vulUrl,
        vulLevel: form.vulLevel,
        content: this.xssDefend(form.content),
        imgAttachmentIdList: this.attachmentIdList,
        attachmentList: [{ attachmentId: (form.attachmentList[0] && form.attachmentList[0].attachmentId) || '' }],
        // 验证码参数
        geetestChallenge: form.geetestChallenge,
        geetestValidate: form.geetestValidate,
        geetestSeccode: form.geetestSeccode
      };
      if (!params.geetestChallenge) {
        return this.$message.warning('请完成验证');
      } else {
        const Token = window.sessionStorage.getItem('x-csrf-token');
        const s = new Promise((resolve, reject) => {
          this.$http
            .post(`vul/hsrc/vul/report/services/vul/add`, params, { headers: { 'x-csrf-token': Token } })
            .then(res => {
              if (res.status === 200) {
                // 成功200、没有权限501、验证码错误511、没有签名509
                if (res.data.status === 200) {
                  that.resetGeeTest();
                  this.ruleForm = {};
                  this.submitSuccess = true;
                  this.success = true;
                  this.ruleForm.fileList = [];
                  this.$refs.ruleForm.clearValidate();
                  setTimeout(() => {
                    this.submitSuccess = false;
                  }, 5000);
                } else if(res.data.status === 501){
                  this.$message.error('该账号没有权限');
                }else if(res.data.status === 511){
                  this.$message.error('验证码错误');
                }else if(res.data.status === 509){
                  this.$message.error('该账号没有签名');
                }else if(res.data.status === 504){
                  // 判断是否完善个人资料
                  checkAgePromise.then(() =>{
                    if (this.completeFlag == false || this.underage == false ) {
                    //弹窗打开
                      this.complete = true;
                    } else {
                      this.complete = false;
                    }
                  })
                }
              } else{
                that.$message.error(res.data && res.data.message);
                that.resetGeeTest();
                this.captchaObj.reset();
              }
            })
            .catch(error => {
               if (error.response&&(error.response.status == '418'||(error.response.data && error.response.data.status === 418))) {
                 this.$message.error('提醒：您提交的内容可能对网站造成危险，已被网站管理员设置拦截，请检查内容并修改后重试！');
               }
              that.resetGeeTest();
              console.log(error);
            });
        });
      }
    },
    resetGeeTest() {
      setTimeout(() => {
        this.ruleForm.geetestChallenge = null;
        this.ruleForm.geetestValidate = null;
        this.ruleForm.geetestSeccode = null;
        this.$refs.captcha.childNodes[0].remove(this.$refs.captcha.childNodes[0]);
        this.getGeetest();
      }, 100);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    formatDate: function(dateStr, fmt = 'yyyy-MM-dd hh:mm:ss') {
      if (!dateStr) return;
      const date = new Date(dateStr);
      const o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds() // 毫秒
      };

      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
      }
      for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length));
        }
      }
      return fmt;
    }, //限制输入特殊字符
    // btKeyDown: function(e) {
    //   e.target.value = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // btKeyDownName: function(e) {
    //   this.ruleForm.vulTitle = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,\/;'\\\·~！@#￥%……&*（）——\-+={}|《》？：“”、；‘'，。、]/g, '');
    // },
    // btKeyDownHomePage: function(e) {
    //   e.target.value = e.target.value.replace(/[`~!#$%^&*()_\-+=<>?"{}|,\;'\\[\]·~！#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },

    resetFormName() {
      this.$refs.ruleFormName.resetField();
    },

    // 上传附件之前
    beforUploadZip(file) {
      const testmsg = (file.name.substring(file.name.lastIndexOf('.') + 1)).toLowerCase();
      const extension = testmsg === 'zip' || testmsg === '7z' || testmsg === 'rar';
      const isList10M = file.size / 1024 / 1024 < 200;
      let bool = false;

      if (extension) {
        bool = true;
      } else {
        bool = false;
      }

      if (!extension) {
        this.$message.warning('上传文件只能是7z,rar,zip格式');
      }
      if (!isList10M) {
        this.$message.warning('上传文件大小不能超过 200M!');
      }

      return bool && isList10M;
    },
    beforUploadPic(file) {
      // return new Promise((resolve, reject) => {
        const testmsg = (file.name.substring(file.name.lastIndexOf('.') + 1)).toLowerCase();//文件格式全部小写
        const extension = testmsg === 'jpg' || testmsg === 'jpeg' || testmsg === 'png' || testmsg === 'gif';
        const isList10M = file.size / 1024 / 1024 < 2;
        let bool = false;

        if (extension) {
          bool = true;
        } else {
          bool = false;
        }

        if (!extension) {
          this.$message.warning('上传文件只能是jpg,jpeg,png,gif格式');
        }
        if (!isList10M) {
          this.$message.warning('上传文件大小不能超过2M!');
        }
        // resolve(bool && isList10M);
        return bool && isList10M;
      // });
    },
    // 上传附件成功
    handlePreviewZip(file) {
      this.uploadMsg = '您上传的文件正在扫描中';
      this.submitDisabled = false;
      const Token = window.sessionStorage.getItem('x-csrf-token');
      this.ruleForm.attachmentList = [{ attachmentId: file[0] }];
      this.pollingDataInterval = setInterval(() => {
        this.$http
          .get(`vul/hsrc/vul/report/services/filetask/single?attachmentId=${file[0]}`, { headers: { 'x-csrf-token': Token } })
          .then(res => {
            if (res.data && res.data.status === 200) {
              const data = res.data.data;
              if (Number(data) > 5) {
                console.log("已扫描超过五次")
              } else {
                this.arrMsg.forEach((e, i) => {
                  if (Number(data) === i + 1) {
                    this.uploadMsg = e;
                  }
                });
                if(this.uploadMsg === '检测到上传的附件存在病毒'){
                  this.submitDisabled = true;
                } else {
                  this.submitDisabled = false;
                }
                clearInterval(this.pollingDataInterval);
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      }, 20000);
    },
    // 富文本图片插入成功
    handlePreview(file) {
      this.logoUrl = `https://${this.$baseU}.honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/res/image?attachmentId=${file[0]}`;
      this.attachmentIdList.push(file[0]);
      const quill = this.$refs.QuillEditor.quill;
      // 如果上传成功
      // 获取光标所在位置
      const length = quill.getSelection().index;
      // 插入图片，res为服务器返回的图片链接地址
      quill.insertEmbed(length, 'image', this.logoUrl);
      // 调整光标到最后
      quill.setSelection(length + 1);
    }
  }
};
</script>

<style lang="less" scoped>
 @import '../../global/variable';
.warnning-wrap {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  h3 {
    text-align: center;
  }
  .content-wrap {
    padding: 80px 10px;
    ul {
      padding-left: 20px;
    }
    span a {
      text-decoration: none;
    }
  }
  .xui-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff !important;
      border-color: #66b1ff;
      color: #fff;
    }
  }
}
/deep/.xui-form-item {
  margin-bottom: 22px;
}

/deep/ .xui-button--medium {
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 4px;
}
/deep/ .xui-button {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  &:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background: #fff;
  }
}
/deep/ .xui-upload__tip {
  line-height: normal;
  margin-left: 1rem;
  font-weight: 600;
  font-size: 12px;
  color: #606266;
  margin-top: 7px;
  display: inline;
}

.item-dropdown {
  font-size: 14px !important;
}

/deep/.xui-form-item.is-error.is-required {
  .ql-toolbar.ql-snow {
    border-color: #f06c7c;
  }
  .ql-container.ql-snow {
    border-color: #f06c7c;
  }
}
/deep/.item-url .xui-form-item__label {
  &::before {
    color: #fff !important;
    margin-right: 4px;
  }
}
/deep/.dialog-content {
  margin-bottom: 1rem !important;
  text-align: center !important;
  font-size: 1rem;
  .img-status {
    width: 2rem;
  }
}
.notifyStyle {
  width: 400px;
}
.submit-wrap {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
}
.login-dialog {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  /deep/.xui-dialog__grayheader .xui-dialog__titleBox {
    text-align: center !important;
    .xui-dialog__graytitle {
      font-size: 1.2rem !important;
      font-weight: normal;
      padding-left: 0;
    }
  }
  /deep/.xui-dialog__body {
    padding: 0 2rem !important;
    font-size: 1rem !important;
    line-height: 2;
    text-align: center;
  }
  /deep/.xui-dialog__footer {
    text-align: center;
    padding: 2rem !important;
  }
  /deep/.xui-button.xui-button--primary {
    background: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff;
      border-color: #66b1ff;
    }
    span {
      color: #fff;
      font-size: 0.8rem !important;
      font-weight: normal;
    }
  }
}
.img-and-title {
  display: flex;
  justify-content: center;
  align-items: center;
  .img-success {
    width: 2rem;
  }
  .report-tip-title {
    line-height: 1.2rem !important;
    font-size: 1rem !important;
    color: #666 !important;
    margin-left: 0.5rem;
    font-weight: 550;
  }
}
.dialog__body {
  text-align: initial;
  padding: 25px 25px 30px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  .report-tip {
    color: #e6a23c;
    text-align: center;
    font-size: 0.8rem;
    padding: 0 1rem 0.5rem 1rem;
  }
  p {
    margin-top: 30px;
    font-size: 0.8rem;
  }
}
/deep/.dialog-footer {
  span {
    color: #fff;
    font-size: 14px;
    font-weight: normal;
  }
  .right span {
    color: #333;
  }
}
/deep/.geetest_holder.geetest_hwfullpage .geetest_logo,
.geetest_holder.geetest_hwfullpage .geetest_success_logo {
  display: none !important;
}


// 20220812界面改版需求新增
.report__content{
  display:flex;
  justify-content: space-between;
   .pageDetailMinHeight();
  .pageMaxWidth();
  margin: 0 auto;
  padding-bottom: 245px;
  overflow:hidden;
}

.report__form{
  width: 810px;
  margin-right: 50px;
  padding-top: 20px;
}

.report__form .report__form-row--one,
.report__form .report__form-row--two {
  display: flex;
  white-space: nowrap;
  margin:20px 0 0 0;
  &:first-child{
    margin-top: 0;
  }
}

/deep/.report__form .xui-form-item.is-overflow-hidden .xui-form-item__content {
   overflow:hidden;
}

.report__form .xui-form-item:first-child{
  margin-top:0;
}

.report__form-row--one,
.report__form-row--two{
  display: flex;
}

/deep/.report__form-row--one .xui-form-item.is-required .xui-form-item__label:before,
/deep/.report__form-row--two .xui-form-item.is-required .xui-form-item__label:before{
  content: '';
  margin:0;

}

/deep/.report__form-row--two .xui-form-item .xui-form-item__label,
/deep/.report__form-row--one .xui-form-item .xui-form-item__label{
  padding: 0;
  flex-basis:0;
  overflow:hidden;
}

.report__form-row--one .xui-form-item__label.is-required:before,
.report__form-row--two .xui-form-item__label.is-required:before{
  content: '*';
    color: #f54d62;
    margin-right: 4px;
    font-size: 18px;
    vertical-align: middle;
    position: relative;
    top: 2px;
}


/deep/.report__form .xui-form-item__label{
  display: flex;
  justify-content: flex-end;
  flex-basis: 100px;
  padding:0;
  line-height: 46px;
  font-size: var(--src--text-size-large-extra1);
  color: var(--src-color-primary-dark4);
  font-weight: var(--src-text-weight-light1);
  text-align: right;
}

/deep/.report__form .xui-form-item__content{
  flex: 1;
  margin-left: 20px;
}

.report__form-row--one .xui-form-item,
.report__form-row--two .xui-form-item{
  flex: 1;
  margin-bottom: 0;
}

/deep/.report__form .xui-form-item .xui-upload-list__item{
  line-height:2;
}

/deep/.report__form .xui-input__inner{
  width: 100%;
  height: 46px;
  line-height: 44px;
  border: 1px solid var(--src-color-secondary-light4);
  border-radius: 4px;
  font-size: var(--src--text-size-medium);
}

.report__form .xui-select,
.report__form .report__quill-editor{
  width: 100%;
}

.report__quill-editor{
  height: 508px;
  overflow: hidden;
 
}

/deep/.report__quill-editor .ql-container{
  display: flex;
  flex-direction: column;
  overflow:hidden;
}

/deep/.report__quill-editor .ql-editor{
  font-size: var(--src--text-size-medium);
  color: var(--src-color-primary-dark4);
  word-break: break-word;
}

.report__quill-editor{
  display: flex;
  flex-direction: column;
  white-space: normal;
}

/deep/.report__form .xui-input .xui-input__icon-height .fa{
  line-height: 44px;
}

/deep/.report__form-button--upload{
  height: 46px;
  line-height: 44px;
  padding:0 13px;
  background: var(--src-text-color-white-dark2);
  border: 1px solid var(--src-color-secondary-light4);
  border-radius: 4px;
  font-size: var(--src--text-size-medium);
  color: var(--src-color-primary-dark4);
  font-weight: var(--src-text-weight-light1);
}

.report__form-upload{
  display:flex;
  flex-wrap: wrap;
  align-items: center;
}

.report__form-tip--upload{
  margin-left: 13px;
  line-height:20px;
  font-size: var(--src--text-size-default);
  color: var(--src-color-primary-dark4);
  font-weight: var(--src-text-weight-light1);
  white-space: normal;
 
}

/deep/.report__form-tip--upload  + div{
  width:100%;
}


.report__form-button--summary {
  margin-left:90px;
  color: var(--src-bg-color-red-light2);
  font-size: var(--src--text-size-small);
}

.report__form-row--submit{
  display:flex;
  justify-content: center;
}

.report__form-button--submit{
  height: 36px;
  line-height: 34px;
  margin-top:30px;
  padding:0 32px;
  background: var(--src-bg-color-blue)!important;
  border-radius: 5px;
  font-size: var(--src--text-size-small);
  color: var(--src-text-color-white)!important;
  font-weight: var(--src-text-weight-light1);
  &:hover{
    opacity: 0.8;
  }
}

.report__program-title{
  padding: 20px 100px 20px 0;
  border-bottom: 1px solid var(--src-color-secondary-light5);
  white-space: nowrap;
  font-size: var(--src--text-size-large-extra3);
  color: var(--src-color-primary-dark2);
  font-weight: var(--src-text-weight-dark1);
}

.program-valid-item{
  width: 350px;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  font-size: var(--src--text-size-medium);
  color: var(--src-text-color-primary-light1);
  font-weight: var(--src-text-weight-light1);
}

.report__program-link{
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
}

.report__program-link:first-child{
  margin-top: 0;
}

.upload_msg-scan{
  color: green;
  font-weight: 600;
  font-size: 12px;
  position: absolute;
  top: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/report/Report.vue